import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { CtExamTemplateList } from 'containers';
import { ExamTemplateMenu, AdminPageTitle, AdminPageTemplate } from 'components';

class CtAdminExamTemplate extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <AdminPageTemplate className="table">
        <AdminPageTitle
          type="table"
          title={defineMessages(formatMessage({ id: 'CtAdminExamTemplate_1', defaultMessage: '훈련 템플릿' }))}>
          <ExamTemplateMenu />
        </AdminPageTitle>
        <CtExamTemplateList />
      </AdminPageTemplate>
    );
  }
}

CtAdminExamTemplate.propTypes = {};
CtAdminExamTemplate.defaultProps = {};

export default injectIntl(CtAdminExamTemplate);



// WEBPACK FOOTER //
// ./src/script/containers/admin/examTemplate/CtAdminExamTemplate.js